
import "./CockpitSettings.scss";
import { FileTextIcon, MasterDataIcon, UserIcon, BellIcon, CockpitSettingsIcon, SecurityIcon } from "../../../../../shared/cockpit/components/icons/Icon";
 
function Settings() {
  const settingCards = [
    {
      id: 1,
      icon: <FileTextIcon />,
      title: "Car-Policy Regeln",
      description:
        "Berechtigungskreise definieren, Kostensplit-Modelle konfigurieren und Fördergrenzen für Wallboxen festlegen.",
    },
    {
      id: 2,
      icon: <MasterDataIcon />,
      title: "Standort-Stammdaten",
      description:
        "Standorte (HQ, Studios) verwalten, Ladepunkte zuordnen und lokale Energietarife hinterlegen.",
    },
    {
      id: 3,
      icon: <UserIcon />,
      title: "Benutzer & Rechte",
      description:
        "Rollen für das Cockpit verwalten (Administrator, Fuhrparkleiter, Personal), Zugriffsrechte steuern und Audit-Log einsehen.",
    },
    {
      id: 4,
      icon: <BellIcon />,
      title: "Benachrichtigungen",
      description:
        "E-Mail-Vorlagen für Anträge bearbeiten, Eskalationsregeln für Alerts definieren und Erinnerungsintervalle setzen.",
    },
    {
      id: 5,
      icon: <CockpitSettingsIcon />,
      title: "Partner-Konfiguration",
      description:
        "Technische Anbindung der Installationspartner, Energieversorger und Backend-Systeme (API-Keys, Endpoints).",
    },
    {
      id: 6,
      icon: <SecurityIcon />,
      title: "Datenschutz & Sicherheit",
      description:
        "Löschfristen für Ladedaten konfigurieren, DSGVO-Einstellungen und Export-Logs.",
    },
  ];
 
  return (
    <div className="settings-view">
      <div className="settings-view__header">
        <div>
          <h1 className="settings-view__title">Stammdaten & Einstellungen</h1>
        </div>
        <p className="settings-view__subtitle">
          Konfiguration des Bene-Fit Programms
        </p>
      </div>
 
      <div className="settings-view__grid">
        {settingCards.map((card) => (
          <div key={card.id} className="settings-card">
            <div className="settings-card__icon-wrapper">{card.icon}</div>
            <h3 className="settings-card__title">{card.title}</h3>
            <p className="settings-card__description">{card.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
 
export default Settings;
 